'use strict';exports.__esModule = true;exports.changeAssetsTags = exports.cleanAssets = exports.addAssetToUnsuspend = exports.addAssetToDelete = exports.cloudinaryTags = undefined;var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise,batch = _reduxLoop.Effects.batch;

var cloudinaryTags = exports.cloudinaryTags = {
  DELETED: 'om_deleted',
  SUSPENDED: 'om_suspended' };


var initialState = {
  loaded: false,
  loading: false,
  toDelete: [],
  toSuspend: [],
  toUnsuspend: [],
  error: null };


var addAssetToDelete = (0, _reduxAct.createAction)('/ADD_ASSET_TO_DELETE');
var addAssetToUnsuspend = (0, _reduxAct.createAction)('/ADD_ASSET_TO_UNSUSPEND');
var cleanAssets = (0, _reduxAct.createAction)('/CLEAN_ASSETS');

var changeAssetsTags = (0, _reduxAct.createAction)('/CHANGE_ASSETS_TAGS');
var changeAssetsTagsSuccess = (0, _reduxAct.createAction)('/CHANGE_ASSETS_TAGS_SUCCESS');
var changeAssetsTagsFailed = (0, _reduxAct.createAction)('/CHANGE_ASSETS_TAGS_FAILED');

var getResourcesToRequest = function getResourcesToRequest() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];return data.reduce(function (acc, _ref) {var type = _ref.type,id = _ref.id;
    acc[type] instanceof Array ? acc[type].push(id) : acc[type] = [id];
    return acc;
  }, {});};

var handleAddAssetToDelete = function handleAddAssetToDelete(state, _ref2) {var type = _ref2.type,id = _ref2.id;return Object.assign({},
  state, {
    toDelete: [].concat(state.toDelete, [{ type: type, id: id }]) });};


var handleAddAssetToUnsuspend = function handleAddAssetToUnsuspend(state, _ref3) {var type = _ref3.type,id = _ref3.id;return Object.assign({},
  state, {
    toUnsuspend: [].concat(state.toUnsuspend, [{ type: type, id: id }]) });};


var handleCleanAssets = function handleCleanAssets() {return Object.assign({},
  initialState);};


var changeAssetsTagsRequest = function changeAssetsTagsRequest(actionType, _ref4) {var type = _ref4.type,_ref4$ids = _ref4.ids,ids = _ref4$ids === undefined ? [] : _ref4$ids,tag = _ref4.tag;return (ids.length ?
  (0, _axios2.default)({
    url: '/assets/cloudinary/' + type + '/tag',
    method: actionType === 'add' ? 'post' : 'delete',
    data: {
      resource_ids: ids,
      tag: tag } }) :


  Promise.resolve()).

  then(changeAssetsTagsSuccess, changeAssetsTagsFailed);};

var buildRequests = function buildRequests(action, tag) {var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};return Object.
  keys(data).
  map(function (key) {return promise(changeAssetsTagsRequest, action, { tag: tag, type: key, ids: data[key] });});};

var handleChangeAssetsTags = function handleChangeAssetsTags(state) {
  var dataToDelete = getResourcesToRequest(state.toDelete);
  var dataToSuspend = getResourcesToRequest(state.toSuspend);
  var dataToUnsuspend = getResourcesToRequest(state.toUnsuspend);

  var requestsToDelete = buildRequests('add', cloudinaryTags.DELETED, dataToDelete);
  var requestsToSuspend = buildRequests('add', cloudinaryTags.SUSPENDED, dataToSuspend);
  var requestsToUnsuspend = buildRequests('remove', cloudinaryTags.SUSPENDED, dataToUnsuspend);

  return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true }),
  batch([].concat(
  requestsToDelete,
  requestsToSuspend,
  requestsToUnsuspend)));

};

var handleChangeAssetsTagsSuccess = function handleChangeAssetsTagsSuccess() {return Object.assign({},
  initialState);};


var handleChangeAssetsTagsFailed = function handleChangeAssetsTagsFailed(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while changing cloudinary tags');
  console.error(error);
  return Object.assign({},
  initialState);

};

var assetsToDelete = (0, _reduxAct.createReducer)(function (on) {
  on(addAssetToDelete, handleAddAssetToDelete);
  on(addAssetToUnsuspend, handleAddAssetToUnsuspend);
  on(cleanAssets, handleCleanAssets);

  on(changeAssetsTags, handleChangeAssetsTags);
  on(changeAssetsTagsSuccess, handleChangeAssetsTagsSuccess);
  on(changeAssetsTagsFailed, handleChangeAssetsTagsFailed);
}, initialState);exports.


addAssetToDelete = addAssetToDelete;exports.
addAssetToUnsuspend = addAssetToUnsuspend;exports.
cleanAssets = cleanAssets;exports.
changeAssetsTags = changeAssetsTags;exports.default =


assetsToDelete;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/assetsToDelete.js
// module id = 168
// module chunks = 0